import SitePageCardsAdmin from "@/project/jain_elibrary-admin/pages/content/SitePageCardsAdmin";

const Committee = () => (
  <SitePageCardsAdmin pageSlug="committee" heading="Committee (site)" />
);

export default Committee;
